import { TextHThreeIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Heading3 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextHThreeIcon size={Sizes[size]} {...rest} color={fill} />;
};

Heading3.displayName = 'Heading3';
